import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from 'react-bootstrap';
import { useFieldArray, useFormContext } from 'react-hook-form';
import config from 'config';

import SingleLineItemGroup from "./SingleLineItemGroup";
import moment from 'moment';
import './LineItemGroups.scss';
import BasePrompt from "components/base/prompt/BasePrompt";
import CustomTitleWithInput from "components/base/CustomTitleWithInput";

const promptConfig = [
  {
    title: "Apply minimum requirement to every line item",
    description: "Once confirmed below setting will apply to every line item. Any existing input value in the line item will be replaced.",
  },
  {
    title: "Once confirmed will replace the existing input in each line item, confirm?",
    description: "",
  },
];

const MinPerLineItem = ({
  title,
  defaultValue,
  setValue,
  per,
  unit,
}) => (
  <CustomTitleWithInput
    title={title}
    type='number'
    defaultValue={defaultValue}
    setValue={setValue}
    useDefaultValue={false}
    per={per}
    unit={unit}
  />
)

const LineItemGroups = ({
  prefix="",
}) => {
  const dispatch = useDispatch();
  const [showApplyMin, setShowApplyMin] = useState(false);
  const [promptStep, setPromptStep] = useState(0);
  const [minSpending, setMinSpending] = useState(null);
  const [minQuantity, setMinQuantity] = useState(null);
  const { control, setValue } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: `${prefix}lineItemGroups`,
  });

  useEffect(() => {
    if (config.generalPurchaseEarningRuleUseShopifySku) {
      dispatch({ type: 'shopify/getProductList' });
    }
  }, []);

  useEffect(() => {
    if (showApplyMin) {
      setPromptStep(0);
      setMinSpending(null);
      setMinQuantity(null);
    }
  }, [showApplyMin])

  return (
    <div className="line-item-group-container">
      <div className="line-item-group-title-container">
        <label class="create-section-title">TRANSACTION</label>
        <Button
          onClick={() => {
            setShowApplyMin(true);
          }}
          className="btn-back-button-common"
        >
          Apply the same minimum requirement to every line item
        </Button>
      </div>
      {fields
        ? fields?.map(
          (group, index) => (
            <SingleLineItemGroup
              key={group.pk || group.temporaryPk}
              index={index}
              removeGroup={remove}
              prefix={prefix}
            />
          )
        )
        : null}
      <Button
        onClick={() => {
          append({
            temporaryPk: moment().toISOString(),
            minimumSpending: null,
            minimumQuantity: null,
            requirements: [],
          });
        }}
        className="btn-back-button-common add-sub-category-btn"
      >
        + Add Line Item Group
      </Button>
      <BasePrompt
        show={showApplyMin}
        title={promptConfig[promptStep].title}
        description={promptConfig[promptStep].description}
        otherBody={() => {
          if (promptStep === 1) {
            return null;
          };
          return (
            <>
              <MinPerLineItem
                title="Minimum spending per line item (optional)"
                defaultValue={minSpending}
                setValue={setMinSpending}
                per='HK$'
              />
              <MinPerLineItem
                title="Minimum quantity per line item (optional)"
                defaultValue={minQuantity}
                setValue={setMinQuantity}
                unit='Items'
              />
            </>
          );
        }}
        closeAction={() => setShowApplyMin(false)}
        leftButton={{
          text: 'Cancel',
          action: () => {
            setShowApplyMin(false);
          },
        }}
        rightButton={{
          text: 'Confirm',
          action: () => {
            if (promptStep === 1) {
              // eslint-disable-next-line no-unused-expressions
              fields?.forEach((item, index) => {
                setValue(`${prefix}lineItemGroups.${index}.minimumSpending`, minSpending, { shouldDirty: true });
                setValue(`${prefix}lineItemGroups.${index}.minimumQuantity`, minQuantity, { shouldDirty: true });
              });
              setShowApplyMin(false);
              return;
            };
            setPromptStep(1);
          },
        }}
      />
    </div>
  );
}

export default LineItemGroups;
